/**
 * Shared Node (Adonis) API origin for administration and Flashback.
 * Env: `REACT_APP_NODE_API_URL` — origin only, no trailing slash.
 */
export function getNodeApiBaseUrl(): string {
  const raw = process.env.REACT_APP_NODE_API_URL ?? 'http://localhost:5000';
  const s = String(raw).trim().replace(/\/$/, '');
  return s === '' ? 'http://localhost:5000' : s;
}
